module.exports = "pegasus_template/assets/background-patterns/fall-space-theme.jpg";